interface ButtonProps {
  url: string;
  label: string;
  className?: string;
}
export const ButtonSecondary = ({ url, label, className }: ButtonProps) => (
  // <Link
  //   to={url}
  //   className="cursor px-4 py-2 text-sm font-semibold bg-gray-800 border border-solid border-slate-200 rounded-full transition-[background-color] duration-[0.2s] ease-[ease] text-slate-900 dark:text-white max-md:hidden"
  // >
  //   {label}
  // </Link>
  <a
    href={url}
    className={`px-4 py-2 text-center focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:cursor-not-allowed aria-disabled:opacity-75 flex-shrink-0 font-medium rounded-full text-sm gap-x-1.5 p-1.5 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-primary/40 dark:ring-primary/45 dark:hover:ring-primary/80 text-gray-700 dark:text-violet-100 bg-gray-50 hover:bg-gray-100 disabled:bg-gray-50 aria-disabled:bg-gray-50 dark:bg-[#3a1260] dark:hover:bg-[#4a1978] dark:disabled:bg-gray-800 dark:aria-disabled:bg-gray-800 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400 inline-flex items-center justify-center leading-none transition-all duration-200 ease-out hover:-translate-y-0.5 hover:shadow-md active:translate-y-0 active:shadow-sm motion-reduce:transition-none motion-reduce:hover:translate-y-0 ${className ?? ""}`}
  >
    {label}
  </a>
);
export const ButtonSecondary2 = ({ url, label }: ButtonProps) => (
  // <Link
  //   to={url}
  //   className="cursor px-4 py-2 text-sm font-semibold bg-gray-800 border border-solid border-slate-200 rounded-full transition-[background-color] duration-[0.2s] ease-[ease] text-slate-900 dark:text-white max-md:hidden"
  // >
  //   {label}
  // </Link>
  <a
    href={url}
    className="px-4 py-2 text-center focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:cursor-not-allowed aria-disabled:opacity-75 flex-shrink-0 font-medium rounded-full text-sm gap-x-1.5 p-1.5 shadow-sm ring-1 ring-inset ring-black/30 dark:ring-primary/30 dark:hover:ring-primary text-stale-800 dark:text-primary dark:hover:text-primary bg-gray-50 hover:bg-gray-100 disabled:bg-gray-50 aria-disabled:bg-gray-50 dark:bg-primary/10 dark:hover:bg-primary/20 dark:disabled:bg-gray-800 dark:aria-disabled:bg-gray-800 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400 hover:-translate-y-0 hover:duration-300 inline-flex items-center justify-center leading-none"
  >
    {label}
  </a>
);
export const ButtonSocial = ({ url, label }: ButtonProps) => (
  // <Link
  //   to={url}
  //   className="cursor px-4 py-2 text-sm font-semibold bg-gray-800 border border-solid border-slate-200 rounded-full transition-[background-color] duration-[0.2s] ease-[ease] text-slate-900 dark:text-white max-md:hidden"
  // >
  //   {label}
  // </Link>
  <a
    href={url}
    className="px-4 py-2 text-center focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:cursor-not-allowed aria-disabled:opacity-75 flex-shrink-0 font-medium rounded-full text-sm gap-x-1.5 p-1.5 shadow-sm ring-1 ring-inset ring-black/30 dark:ring-white/30 dark:hover:ring-primary text-stale-800 dark:text-gray-300 dark:hover:text-white bg-gray-50 hover:bg-gray-100 disabled:bg-gray-50 aria-disabled:bg-gray-50 dark:bg-gray-600/50 dark:hover:bg-primary dark:disabled:bg-gray-800 dark:aria-disabled:bg-gray-800 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400 hover:-translate-y-0.5 hover:duration-300 inline-flex items-center justify-center leading-none"
  >
    {label}
  </a>
);
export default ButtonSecondary;
